
import React, { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalUrl?: string;
  structuredData?: object;
}

export function SEOHead({
  title = "National Airports Corporation PNG - Flight Radar",
  description = "Your Flight Radar, Brought to You By National Airports Corporation PNG",
  keywords = "PNG flights, Papua New Guinea flights, flight tracker, airport departures, arrivals, flight status, PNG aviation, NAC, National Airports Corporation",
  ogImage = "/NAC_logo.png",
  canonicalUrl,
  structuredData
}: SEOHeadProps) {
  useEffect(() => {
    console.log('SEOHead updating with:', { title, description, ogImage });
    
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, property?: boolean) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      
      if (!meta) {
        meta = document.createElement('meta');
        if (property) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
        console.log(`Created new meta tag: ${name}`);
      }
      meta.setAttribute('content', content);
      console.log(`Updated meta tag ${name} with content: ${content}`);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Open Graph tags - using boolean parameter properly
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', ogImage, true);
    updateMetaTag('og:type', 'website', true);

    // Twitter tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);

    // Canonical URL
    if (canonicalUrl) {
      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', canonicalUrl);
    }

    // Structured data
    if (structuredData) {
      let script = document.querySelector('script[type="application/ld+json"]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(structuredData);
    }
    
    // Log final meta tags to verify
    console.log('Final meta tags in DOM:');
    console.log('og:title:', document.querySelector('meta[property="og:title"]')?.getAttribute('content'));
    console.log('og:description:', document.querySelector('meta[property="og:description"]')?.getAttribute('content'));
    console.log('og:image:', document.querySelector('meta[property="og:image"]')?.getAttribute('content'));
    console.log('twitter:title:', document.querySelector('meta[name="twitter:title"]')?.getAttribute('content'));
    console.log('twitter:image:', document.querySelector('meta[name="twitter:image"]')?.getAttribute('content'));
  }, [title, description, keywords, ogImage, canonicalUrl, structuredData]);

  return null;
}
